import React, { useEffect, useState, useRef } from "react"

import { FaBars, FaSearch } from "react-icons/fa"

import { Row, Col, Input, Button, Spinner } from "reactstrap"
import { Formik, Form, Field } from "formik"

import PlayerInfo from "pages/Joueurs/companents/PlayerInfo"
import Annonce from "./Annonce"
import PaginationComponent from "./Paginations"
import { useDispatch, useSelector } from "react-redux"
import { getAll, setCurrentPage } from "store/slices/playerSlice"
import FilterComponenent from "./Filter"
import Header from "./Header"
const PlayersList = () => {
  const dispatch = useDispatch()
  const [selectedAgeValue, setSelectedAgeValue] = useState(null)
  const [selectedPositionValue, setSelectedPositionValue] = useState(null)
  const [selectedLevelValue, setSelectedLevelValue] = useState(null)
  const [searchValue, setSearchValue] = useState("")

  const { players, totalItems, totalPages, currentPage, fetchLoading } =
    useSelector((state) => state.Player)

  const listRef = useRef(null)
  const firstRender = useRef(true)

  useEffect(() => {
    dispatch(
      getAll({
        page: currentPage,
        age: selectedAgeValue,
        position: selectedPositionValue,
        level: selectedLevelValue,
        searchValue: searchValue,
      })
    ).then(() => {
      if (!firstRender.current) {
        listRef.current?.scrollIntoView({ behavior: "smooth" })
      } else {
        firstRender.current = false
      }
    })
  }, [currentPage])

  return (
    <Row style={{ marginTop: 25 }}>
      <Col lg={9}>
        <Row>
          <Formik
            initialValues={{ search: "" }}
            onSubmit={(values) => {
              setSearchValue(values.search)
              if (currentPage === 1) {
                dispatch(
                  getAll({
                    page: 1,
                    age: selectedAgeValue,
                    position: selectedPositionValue,
                    level: selectedLevelValue,
                    searchValue: values.search,
                  })
                )
              } else {
                dispatch(setCurrentPage(1))
              }
            }}
          >
            {({ handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    borderRadius: 10,
                  }}
                >
                  <Field
                    name="search"
                    as={Input}
                    placeholder="Recherchez un joueur par son nom et son prénom"
                    style={{
                      paddingRight: "30px",
                      borderRadius: 15,
                      border: "1 solid #000000",
                    }}
                  />
                  <FaSearch
                    onClick={handleSubmit}
                    style={{
                      position: "absolute",
                      right: "10px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      cursor: "pointer",
                      color: "#000000",
                    }}
                  />
                </div>
              </Form>
            )}
          </Formik>
        </Row>

        <Row>
          <FilterComponenent
            selectedAgeValue={selectedAgeValue}
            setSelectedAgeValue={setSelectedAgeValue}
            selectedPositionValue={selectedPositionValue}
            setSelectedPositionValue={setSelectedPositionValue}
            selectedLevelValue={selectedLevelValue}
            setSelectedLevelValue={setSelectedLevelValue}
            setCurrentPage={setCurrentPage}
            getAll={getAll}
            searchValue={searchValue}
          />
          <div ref={listRef}>
            {fetchLoading ? (
              <div style={{ textAlign: "center", padding: "20px" }}>
                <Spinner color="primary" />
              </div>
            ) : players && players.length > 0 ? (
              players.map((player) => (
                <PlayerInfo key={player.id} player={player} />
              ))
            ) : (
              <div style={{ marginTop: 20 }}>Aucun joueur trouvé.</div>
            )}
          </div>
        </Row>
        <PaginationComponent
          totalItems={totalItems}
          totalPages={totalPages}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
        ></PaginationComponent>
      </Col>
      <Annonce></Annonce>
    </Row>
  )
}

export default PlayersList
